import React, { Component } from 'react';

interface EulaFormProps {
  isEulaAccepted: boolean
  onAccept: () => void;
}

interface EulaFormState {
  eulaText: string;
  isAccepted: boolean;
}

class EulaForm extends Component<EulaFormProps, EulaFormState> {
  constructor(props: EulaFormProps) {
    super(props);
    this.state = {
      eulaText: '',
      isAccepted: props.isEulaAccepted,
    };
  }

  componentDidMount() {
    fetch('/eula.txt')
      .then((response) => response.text())
      .then((text) => this.setState({ eulaText: text }));
  }

  handleCheckboxChange = () => {
    this.setState((prevState) => ({ isAccepted: !prevState.isAccepted }));
  };

  handleAccept = () => {
    if (this.state.isAccepted) {
      this.props.onAccept();
    }
  };

  render() {
    return (
      <div>
        <div className="eula-box">
          <h2>End-User License Agreement (EULA)</h2>
          <pre>{this.state.eulaText}</pre>
        </div>
        <div>
          <input
            type="checkbox"
            id="accept"
            checked={this.state.isAccepted}
            onChange={this.handleCheckboxChange}
          />
          <label htmlFor="accept">I Accept</label>
        </div>
        <button onClick={this.handleAccept} disabled={!this.state.isAccepted}>
          Accept
        </button>
      </div>
    );
  }
}

export default EulaForm;